import axios from "axios";
import { generateTraceId } from "../../helpers";

export const getCardsToMigrate = async clientId => {
  const baseURL = process.env.REACT_APP_API_URL;
  if (!clientId) {
    throw new Error("client_id é obrigatório");
  }

  try {
    const response = await axios.get(
      `${baseURL}/subscription/client-pagarme-sync/${encodeURIComponent(
        clientId
      )}`,
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      `Erro ao buscar dados do cartão para migração: ${error?.response
        ?.status || error.message}`
    );
  }
};
